import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  ChevronDown, 
  ChevronUp,
  Phone,
  Clock,
  Shield,
  Car
} from 'lucide-react';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  const faqData = [
    {
      category: "Allgemeine Fragen",
      questions: [
        {
          question: "Was ist Auto-Glass Mannheim?",
          answer: "Auto-Glass Mannheim ist Ihr professioneller Partner für Autoglas Reparatur und Austausch in Mannheim, Frankfurt und Stuttgart. Wir bieten hochwertige Dienstleistungen mit über 15 Jahren Erfahrung."
        },
        {
          question: "In welchen Städten sind Sie tätig?",
          answer: "Wir sind in Mannheim (Hauptstandort), Frankfurt am Main und Stuttgart tätig. In Frankfurt und Stuttgart bieten wir mobile Reparatur an, während wir in Mannheim auch eine Werkstatt haben."
        },
        {
          question: "Welche Fahrzeugtypen reparieren Sie?",
          answer: "Wir reparieren alle gängigen Fahrzeugtypen: Pkw, Lkw, Transporter, Motorräder und Nutzfahrzeuge aller Marken und Modelle."
        }
      ]
    },
    {
      category: "Autoglas Reparatur",
      questions: [
        {
          question: "Wann kann eine Autoglas Reparatur durchgeführt werden?",
          answer: "Eine Reparatur ist möglich bei Steinschlägen bis zu 3cm Durchmesser und Rissen bis zu 30cm Länge. Die Beschädigung sollte nicht im direkten Sichtfeld des Fahrers liegen."
        },
        {
          question: "Wie lange dauert eine Autoglas Reparatur?",
          answer: "Eine typische Autoglas Reparatur dauert zwischen 30 und 60 Minuten. Die genaue Zeit hängt von der Art und Größe der Beschädigung ab."
        },
        {
          question: "Ist eine reparierte Windschutzscheibe sicher?",
          answer: "Ja, eine professionell reparierte Windschutzscheibe ist genauso sicher wie eine unbeschädigte. Die Reparatur stellt die ursprüngliche Festigkeit wieder her."
        },
        {
          question: "Kann ich nach der Reparatur sofort fahren?",
          answer: "Ja, Sie können nach der Reparatur sofort weiterfahren. Das verwendete Harz härtet innerhalb weniger Minuten aus."
        }
      ]
    },
    {
      category: "Autoglas Austausch",
      questions: [
        {
          question: "Wann ist ein Austausch der Windschutzscheibe notwendig?",
          answer: "Ein Austausch ist notwendig bei: Rissen länger als 30cm, Steinschlägen größer als 3cm, Beschädigungen im direkten Sichtfeld, oder wenn die Reparatur nicht mehr möglich ist."
        },
        {
          question: "Wie lange dauert ein Windschutzscheiben Austausch?",
          answer: "Ein kompletter Austausch dauert zwischen 2 und 4 Stunden, abhängig vom Fahrzeugmodell und der Komplexität der Arbeit."
        },
        {
          question: "Welche Scheiben verwenden Sie?",
          answer: "Wir verwenden ausschließlich hochwertige Original- oder Markenersatzteile namhafter Hersteller wie Pilkington, Saint-Gobain oder AGC."
        },
        {
          question: "Muss ich nach dem Austausch warten?",
          answer: "Ja, nach dem Austausch sollten Sie 1-2 Stunden warten, bis der Kleber vollständig ausgehärtet ist. Wir informieren Sie über die genaue Wartezeit."
        }
      ]
    },
    {
      category: "Preise & Kosten",
      questions: [
        {
          question: "Was kostet eine Autoglas Reparatur?",
          answer: "Die Kosten für eine Reparatur liegen zwischen 30€ und 80€, abhängig von der Größe und Art der Beschädigung. Wir bieten kostenlose Beratung und transparente Preisgestaltung."
        },
        {
          question: "Was kostet ein Windschutzscheiben Austausch?",
          answer: "Die Kosten für einen Austausch variieren zwischen 150€ und 500€, je nach Fahrzeugmodell und Scheibentyp. Wir erstellen Ihnen gerne ein individuelles Angebot."
        },
        {
          question: "Übernehmen Versicherungen die Kosten?",
          answer: "Ja, viele Kfz-Versicherungen übernehmen die Kosten für Autoglas Reparatur und Austausch. Wir helfen Ihnen bei der Abwicklung mit Ihrer Versicherung."
        },
        {
          question: "Gibt es Rabatte für mehrere Reparaturen?",
          answer: "Ja, bei mehreren Reparaturen oder für Stammkunden bieten wir attraktive Rabatte. Sprechen Sie uns gerne darauf an."
        }
      ]
    },
    {
      category: "Termine & Service",
      questions: [
        {
          question: "Wie schnell können Sie einen Termin anbieten?",
          answer: "Wir bieten in der Regel Termine innerhalb von 24-48 Stunden an. Bei Notfällen sind wir auch kurzfristig verfügbar."
        },
        {
          question: "Bieten Sie auch mobile Reparatur an?",
          answer: "Ja, wir bieten mobile Reparatur in Mannheim, Frankfurt und Stuttgart an. Wir kommen zu Ihnen nach Hause oder an Ihren Arbeitsplatz."
        },
        {
          question: "Gibt es einen Notfallservice?",
          answer: "Ja, wir bieten 24/7 Notfallservice für dringende Reparaturen. Sie erreichen uns rund um die Uhr unter 0621 71895675."
        },
        {
          question: "Welche Öffnungszeiten haben Sie?",
          answer: "Mo-Fr: 8:00-18:00 Uhr, Sa: 9:00-14:00 Uhr. Notfallservice ist 24/7 verfügbar."
        }
      ]
    },
    {
      category: "Garantie & Qualität",
      questions: [
        {
          question: "Geben Sie Garantie auf Ihre Arbeiten?",
          answer: "Ja, wir geben umfassende Garantie auf alle unsere Arbeiten: Reparatur Garantie, Material Garantie und Arbeitsgarantie."
        },
        {
          question: "Wie lange gilt die Garantie?",
          answer: "Unsere Garantie gilt für 2 Jahre auf Reparaturen und 3 Jahre auf Austauscharbeiten. Details erhalten Sie bei der Auftragsvergabe."
        },
        {
          question: "Sind Ihre Techniker zertifiziert?",
          answer: "Ja, alle unsere Techniker sind zertifiziert und absolvieren regelmäßige Weiterbildungen. Wir arbeiten nach höchsten Qualitätsstandards."
        },
        {
          question: "Welche Qualitätsstandards haben Sie?",
          answer: "Wir arbeiten nach DIN-Normen und verwenden nur hochwertige Materialien namhafter Hersteller. Alle Arbeiten werden von erfahrenen Technikern durchgeführt."
        }
      ]
    }
  ];

  return (
    <>

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Häufige Fragen
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              Antworten auf die wichtigsten Fragen zur Autoglas Reparatur
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Häufig gestellte Fragen
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Finden Sie schnell Antworten auf Ihre Fragen zur Autoglas Reparatur und unseren Dienstleistungen
            </p>
          </motion.div>

          <div className="space-y-12">
            {faqData.map((category, categoryIndex) => (
              <motion.div
                key={categoryIndex}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: categoryIndex * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  {categoryIndex === 0 && <Car size={24} className="text-blue-600 mr-3" />}
                  {categoryIndex === 1 && <Shield size={24} className="text-blue-600 mr-3" />}
                  {categoryIndex === 2 && <Clock size={24} className="text-blue-600 mr-3" />}
                  {categoryIndex === 3 && <Phone size={24} className="text-blue-600 mr-3" />}
                  {categoryIndex === 4 && <Shield size={24} className="text-blue-600 mr-3" />}
                  {categoryIndex === 5 && <Shield size={24} className="text-blue-600 mr-3" />}
                  {category.category}
                </h3>
                
                <div className="space-y-4">
                  {category.questions.map((item, itemIndex) => {
                    const globalIndex = categoryIndex * 100 + itemIndex;
                    const isOpen = openItems.has(globalIndex);
                    
                    return (
                      <motion.div
                        key={itemIndex}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: itemIndex * 0.1 }}
                        viewport={{ once: true }}
                        className="border border-gray-200 rounded-lg overflow-hidden"
                      >
                        <button
                          onClick={() => toggleItem(globalIndex)}
                          className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
                        >
                          <span className="font-semibold text-gray-900 pr-4">
                            {item.question}
                          </span>
                          {isOpen ? (
                            <ChevronUp size={20} className="text-blue-600 flex-shrink-0" />
                          ) : (
                            <ChevronDown size={20} className="text-blue-600 flex-shrink-0" />
                          )}
                        </button>
                        
                        <motion.div
                          initial={false}
                          animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
                          transition={{ duration: 0.3 }}
                          className="overflow-hidden"
                        >
                          <div className="px-6 py-4 bg-white border-t border-gray-200">
                            <p className="text-gray-600 leading-relaxed">
                              {item.answer}
                            </p>
                          </div>
                        </motion.div>
                      </motion.div>
                    );
                  })}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Quick Contact */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Haben Sie weitere Fragen?
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Falls Sie hier keine Antwort auf Ihre Frage gefunden haben, 
              kontaktieren Sie uns gerne direkt. Wir helfen Ihnen weiter!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:062171895675"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <Phone size={24} />
                <span>Jetzt anrufen: 0621 71895675</span>
              </a>
              <a
                href="mailto:info@autoglass-mannheim.de"
                className="bg-transparent border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300"
              >
                E-Mail senden
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Unsere Dienstleistungen im Überblick
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Alles was Sie über unsere Autoglas Dienstleistungen wissen müssen
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Autoglas Reparatur",
                description: "Professionelle Reparatur von Steinschlägen und Rissen",
                duration: "30-60 Min",
                price: "ab 30€",
                features: ["Steinschlag Reparatur", "Riss Reparatur", "Sofortige Fertigstellung", "Garantie"]
              },
              {
                title: "Autoglas Austausch",
                description: "Kompletter Austausch beschädigter Scheiben",
                duration: "2-4 Std",
                price: "ab 150€",
                features: ["Windschutzscheibe", "Seitenscheiben", "Heckfenster", "Qualitätsgarantie"]
              },
              {
                title: "Scheibenversiegelung",
                description: "Professionelle Versiegelung für optimalen Schutz",
                duration: "1-2 Std",
                price: "ab 80€",
                features: ["Hydrophobe Beschichtung", "UV-Schutz", "Kratzfestigkeit", "Langlebigkeit"]
              }
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="bg-gray-50 p-8 rounded-xl"
              >
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {service.description}
                </p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-sm text-gray-500">
                    <Clock size={16} className="inline mr-1" />
                    {service.duration}
                  </span>
                  <span className="text-lg font-semibold text-blue-600">
                    {service.price}
                  </span>
                </div>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-gray-700">
                      <Shield size={16} className="text-green-500 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Bereit für Ihre Autoglas Reparatur?
            </h2>
            <p className="text-xl mb-8 text-blue-100 max-w-3xl mx-auto">
              Kontaktieren Sie uns jetzt für ein kostenloses Angebot oder einen Termin.
            </p>
            <a
              href="tel:062171895675"
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-300 inline-flex items-center space-x-2"
            >
              <Phone size={24} />
              <span>Jetzt anrufen: 0621 71895675</span>
            </a>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default FAQ; 